import { useEffect, useState } from "react";

import { TableQuery } from "@ezmid/components-library";
import { useNavigate } from "react-router";

import ApplicationRoute from "../features/route/ApplicationRoute";

export const removeEmptyQueries = (url: string): string => {
  const [baseUrl, queryString] = url.split("?");
  if (!queryString) {
    return baseUrl;
  }

  const filteredQueries = queryString.split("&").filter((item) => {
    return !(item.includes("undefined") || item.endsWith("="));
  });

  const sanitizedQueryString = filteredQueries.join("&");
  const sanitizedURL = `${baseUrl}?${sanitizedQueryString}`;

  return sanitizedURL;
};

export function useTableQuery(
  key: string,
  defaultQuery: TableQuery,
  route: ApplicationRoute
) {
  const [query, setQuery] = useState<TableQuery>(() => {
    const storedQuery = localStorage.getItem(key);
    return storedQuery ? JSON.parse(storedQuery) : defaultQuery;
  });
  const navigate = useNavigate();

  useEffect(
    function storeQueryToLocalStorage() {
      localStorage.setItem(key, JSON.stringify(query));
    },
    [query]
  );

  const updateQuery = (newQuery: TableQuery) => {
    setQuery(newQuery);
  };

  useEffect(
    function updateURLWithQueryParams() {
      const queryString = `${route.path}?page=${query.pageIndex}&keyword=${query?.keyword}&size=${query.pageSize}&sort=${query?.sortBy?.key}:${query?.sortBy?.order}`;
      const sanitizedURL = removeEmptyQueries(queryString);
      navigate(sanitizedURL);
    },
    [query]
  );

  return {
    query,
    updateQuery,
  };
}
